export default [
  {
    path: 'dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard/Dashboard.vue'),
    meta: {
      title: 'Bảng thông tin chung',
      auth: true,
    },
  },
]
